import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const currentUserId = () => {
  try { return JSON.parse(localStorage.getItem('user') || '{}').id || null; } catch { return null; }
};

// Loads the org picked via ?org_id= (or the first org) plus its members.
export const useOrgData = () => {
  const location = useLocation();
  const [org, setOrg] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const orgId = new URLSearchParams(location.search).get('org_id');
      const { data: list = [] } = await axios.get(`${API}/organizations/mine`, { headers: authHeaders() });
      const picked = orgId ? list.find((o) => o.id === orgId) : list[0];
      if (!picked) return;
      setOrg(picked);
      const memRes = await axios.get(`${API}/organizations/${picked.id}/members`, { headers: authHeaders() });
      setMembers(memRes.data || []);
    } catch (e) {
      console.error('Failed to load org:', e);
    } finally {
      setLoading(false);
    }
  }, [location.search]);

  useEffect(() => { load(); }, [load]);

  const myRole = members.find((m) => m.user_id === currentUserId())?.role;
  return {
    org,
    members,
    loading,
    myRole,
    isOwner: myRole === 'owner',
    canManage: myRole === 'owner' || myRole === 'admin',
    reload: load,
  };
};

export { API, authHeaders };
